import { render, staticRenderFns } from "./firsttabbar.vue?vue&type=template&id=4aae5b26&scoped=true"
import script from "./firsttabbar.vue?vue&type=script&lang=js"
export * from "./firsttabbar.vue?vue&type=script&lang=js"
import style0 from "./firsttabbar.vue?vue&type=style&index=0&id=4aae5b26&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae5b26",
  null
  
)

export default component.exports